var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 2.5C3 1.67157 3.67157 1 4.5 1H11.5C12.3284 1 13 1.67157 13 2.5V12H3V2.5ZM2 12.5V2.5C2 1.11929 3.11929 0 4.5 0H11.5C12.8807 0 14 1.11929 14 2.5V12.5V13.5C14 14.8807 12.8807 16 11.5 16H4.5C3.11929 16 2 14.8807 2 13.5V12.5ZM13 13V13.5C13 14.3284 12.3284 15 11.5 15H4.5C3.67157 15 3 14.3284 3 13.5V13H13Z"}));
}

Mobile.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Mobile;

Mobile.default = Mobile;
